import { useState } from 'react'

export function useUserIdHook() {
  const [userId, setUserId] = useState('')
  return [userId, setUserId]
}
